import { render, staticRenderFns } from "./TextFieldAlpha.vue?vue&type=template&id=04bd953c"
import script from "./TextFieldAlpha.vue?vue&type=script&lang=js"
export * from "./TextFieldAlpha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports